import React, { useState, useEffect, useCallback } from "react";
import {
    TextField,
    Typography,
    Button,
} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import Grid from "@mui/material/Grid2";
import {Styles} from "../../../../../config/design/styles";
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import OTPField from "../../../../components/elements/fields/OTPField";
import {LockKeyhole, Phone} from "lucide-react";


const LoginUser = ({ user, makeLogin,classes,login_type,has_password,handleOtp }) => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [fields, setFields] = useState({ token: "" });
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [firstSend, SetFirstSend] = useState(false);
    const [timer, setTimer] = useState({ minutes: login_type === "email" ? 5 : 2, seconds: 0 });

    useEffect(() => {
        if (timer.minutes === 0 && timer.seconds === 0) return;

        const interval = setInterval(() => {
            setTimer(({ minutes, seconds }) => {
                if (seconds > 0) return { minutes, seconds: seconds - 1 };
                if (minutes > 0) return { minutes: minutes - 1, seconds: 59 };
                clearInterval(interval);
                return { minutes: 0, seconds: 0 };
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup the interval
    }, [timer]);
    useEffect(() => {
        if(fields.token.length === 5){
            setSubmitLoading(true);
            handleRequest();
        }
    }, [fields]);


    const handleFirstSendToken = async () => {
        if(!firstSend){
            await SetFirstSend(true);
            setSubmitLoading(true);
            try {

                await axios.post(
                    `${defaultVariables.url}/auth/set-user`,
                    {
                        mobile: user.mobile,
                        send_token:true,
                        email: user.email
                    },
                    {
                        headers: {
                            Accept: "application/json",
                        },
                    }
                );
                enqueueSnackbar(t("sendTokenTextResend"), { variant: "info" });
                setTimer({ minutes: 3, seconds: 0 });
            } catch (error) {
                enqueueSnackbar(t("invalidMobileNumber"), { variant: "error" });
            } finally {
                setSubmitLoading(false);
            }
        }
    }
    const handleChange = async (otp) => {
        let name = "token";
        await setFields((prev) => ({ ...prev, [name]: otp }));
        await setErrors((prev) => ({ ...prev, [name]: "" }));

    };

    const validateFields = () => {
        const newErrors = {};
        let formIsValid = true;

        if (!fields.token.trim()) {
            formIsValid = false;
            newErrors.token = t("emptyField");
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleRequest = async () => {
        const { token } = fields;
        try {
            const response = await axios.post(
                `${defaultVariables.url}/auth/check-token`,
                {
                    token,
                    user_id: user.id,
                    login_type: login_type === "email" ? "email" : 'mobile'
                },
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            );
            makeLogin(response.data);
            setSubmitLoading(false);
        } catch (error) {
            console.log(error.response)
            setSubmitLoading(false);
            enqueueSnackbar(t("wrongToken"), { variant: "error" });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (validateFields()) {
            handleRequest();
        } else {
            setSubmitLoading(false);
        }
    };

    const handleResendToken = useCallback(async () => {
        setSubmitLoading(true);
        try {

            await axios.post(
                `${defaultVariables.url}/auth/set-user`,
                {
                    mobile: user.mobile,
                    send_token:true,
                    email: user.email
                },
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            );
            enqueueSnackbar(t("sendTokenTextResend"), { variant: "info" });
            setTimer({ minutes: 3, seconds: 0 });
        } catch (error) {
            enqueueSnackbar(t("invalidMobileNumber"), { variant: "error" });
        } finally {
            setSubmitLoading(false);
        }
    }, [user?.mobile, enqueueSnackbar]);

    return (
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                {
                    (!!has_password && !firstSend) ?
                        <Grid item size={12} style={{textAlign:'center'}}>
                            <Typography style={{marginBottom:10,marginTop:-10}} align="center">{t('pushButtonToSendOTP')}</Typography>
                            <Button
                                style={{marginBottom:10}}
                                variant="contained"
                            onClick={() => handleFirstSendToken()}
                            >
                                {t('sendOTP')}
                            </Button>
                        </Grid>
                    :
                        <>
                            <Grid item size={12}>
                                <OTPField
                                    length={5}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item size={12}  style={{textAlign:"center"}}>
                                <Typography color="textSecondary">
                                    {t("sendTokenText1")}{" "}
                                    <strong dir="ltr">{login_type === "email" ? user?.email : user?.mobile}</strong>{" "}
                                </Typography>
                                {timer.minutes !== 0 || timer.seconds !== 0 ? (
                                    <Typography  color="textSecondary" >
                                        {t("sendTokenText2")}:{" "}
                                        <strong style={{width:45,display:'inline-block'}}>
                                            {timer.minutes}:{timer.seconds < 10 ? `0${timer.seconds}` : timer.seconds}
                                        </strong>
                                    </Typography>
                                ) : (
                                    <Button style={{marginTop:10}} color="secondary" variant="outlined" onClick={() => handleResendToken()}>
                                        {t("sendAgain")}
                                    </Button>
                                )}
                            </Grid>
                            <Grid item size={12} style={{marginTop:30}}>
                                <LoadingButton
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={handleSubmit}
                                    loading={submitLoading}
                                    style={{width:"100%"}}
                                    styleForParent={{margin:"10px 0"}}
                                >
                                    {t("confirm")}
                                </LoadingButton>
                            </Grid>
                        </>

                }


                {
                    !!has_password &&
                    <Grid item size={12} style={{textAlign:"center"}}>
                        <Button
                            color="secondary"
                            onClick={() => handleOtp()}
                            startIcon={<LockKeyhole className="lucide-icon"/>}
                            >
                            {t('loginWithPass')}
                        </Button>
                    </Grid>
                }
            </Grid>
        </form>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginUser));
